export function ourSectionSliders() {

    let $bioSliderNav = new Swiper(".bio-nav", {
        slidesPerView: 3,
        spaceBetween: 10,
        mousewheel: true,
        slideToClickedSlide: true,
        noSwiping: false,
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
        },
        breakpoints: {
            744: {
                slidesPerView: 5,
                spaceBetween: 20
            },
            1200: {
                slidesPerView: 5.35,
                spaceBetween: 24,
                direction: "vertical",
            },
        },
    });

    let $bioSlider = new Swiper(".bio-slider", {
        slidesPerView: 1,
        noSwiping: false,
        thumbs: {
            swiper: $bioSliderNav,
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/ourSectionSliders.js